import React, { useState, useContext, useEffect } from 'react'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import { Button, IconButton } from '@material-ui/core'
import Comments from '@/custom/components/organisms/Comments'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import './ProductView.css'
import ProxyBidding from '@/custom/components/molecules/Bidding/ProxyBidding'
import Buynow from '@/custom/components/molecules/Buynow/BuynowItem'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import { useFormik } from 'formik'
import { dateFormatFront, currencyFormat } from '@/custom/common/components'
// import TertiaryButton from '@/custom/components/atoms/TertiaryButton'
import ReverseBidding from '@/custom/components/molecules/Reverse/Bidding/BiddingItem'
import CustomReverseBidding from '@/custom/components/molecules/Reverse/Bidding/CustomReverseBidding'

import Timer from '@/product/common/timer'
import Bidding from '@/custom/components/molecules/Bidding/BiddingItem'
import ProductContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import Loaders from '@/custom/components/molecules/Loaders'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { handleRedirectInternal } from '@/product/common/components'
import BuyerContext from '../../../../product/context/buyer/buyerContext'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SEO from '@/utils/SEO'
import { mapData } from '@/product/common/components'
import SignContext from '@/custom/context/signContext'
import DynamicView from '../../../../custom/common/Product/ProductDynamic'
import Makeoffer from '@/custom/components/molecules/Makeoffer/MakeofferItem'
import AlertContext from '@/product/context/alert/alertContext'
import CustomDialog from '@/custom/components/organisms/Dialog'
import MessageContext from '@/product/context/message/messageContext'
const isValidHttpUrl = (string) => {
    let url

    try {
        url = new URL(string)
    } catch (err) {
        return false
    }

    return url.protocol === 'http:' || url.protocol === 'https:'
}
const ProductView = (props) => {
    const { t } = useTranslation()

    const [expanded, setExpanded] = useState()
    const [images, setImages] = useState([])
    let [viewProduct, setViewProduct] = useState([])
    const [product, setProduct] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [manage, setManage] = React.useState(false)
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const buyerContext = useContext(BuyerContext)
    const productCommonContext = useContext(ProductCommonContext)
    const alertContext = useContext(AlertContext)
    const { loginPopup, handleLoginPopup, kycPopup, handleKycPopup, handleBusign } =
        useContext(SignContext)
    const {
        bidCancel,
        responseStatus: responseStatusBid,
        clearResponse: clearResponseBid,
    } = buyerContext
    const messageContext = useContext(MessageContext)
    const { isAuthenticated, user } = authContext

    const auctionDetails = props.auctionDetails
    // prettier-ignore
    const {
        search_allsimilar,
        getAllSimilarProducts,
        search_allbidhistory,
        getAllBidHistory,
    } = productContext
    const { setBidHistoryValue } = productCommonContext
    const { setAlert } = alertContext
    const {
        searchactualmessages,
        getAllMessages,
        searchprojectmessages,
        all_messages,
        all_actual_messages,
        all_project_messages,
        deleteMessage,
        searcharchiveMessages,
        saveMessage,
        responseStatus: responseStatusMessage,
    } = messageContext

    const updateLoading = (data) => {
        setIsLoading(data)
    }

    const AccordionDetails = withStyles((theme) => ({
        root: {
            padding: '10px',
        },
    }))(MuiAccordionDetails)

    useEffect(() => {
        setProduct(props.data)
        console.log(props.data, 'proppp')
    }, [props.data])

    const productBiddingStatus = (userInfo, productInfo) => {
        if (product.bidtopstatus && product.bidtopstatus !== '') return product.bidtopstatus

        if (userInfo && productInfo) {
            // return none if no top status
            if (productInfo.bidhistory?.length < 1) {
                return 'none'
            }
            if (didUserBid(userInfo.id, productInfo.bidhistory)) {
                if (productInfo.market_status === 'closed') {
                    if (productInfo.bidwinneruser === userInfo.id) {
                        return 'won'
                    } else {
                        return 'lost'
                    }
                }
                if (productInfo.market_status === 'open') {
                    if (productInfo.bidhistory[0].user_id === userInfo.id) {
                        return 'winner'
                    } else {
                        return 'outbid'
                    }
                }
            }
            return 'none'
            //check if user is winning

            //check
        }
    }

    // useEffect(() => {
    //     setIsLoading(true)

    //     if (product) {
    //         const search = {
    //             limit: 3,
    //             page: 1,
    //             orderby: 'p.date_closed,asc',
    //             order: '',
    //             similars: {
    //                 category: {
    //                     value: [product.categoryTypeId],
    //                     type: 'array',
    //                     field: 'it.categoryTypeId',
    //                 },
    //                 condition: {
    //                     value: [product.conditiontypeid],
    //                     type: 'array',
    //                     field: 'it.conditiontypeid',
    //                 },
    //                 location: {
    //                     value: [product.location_id],
    //                     type: 'array',
    //                     field: 'p.location_id',
    //                 },
    //                 auctionid: {
    //                     value: [product.auctionid],
    //                     type: 'array',
    //                     field: 'p.auctionid',
    //                 },
    //             },
    //             filters: {
    //                 product_id: {
    //                     value: product.id,
    //                     type: 'notin',
    //                     field: 'p.id',
    //                 },
    //             },
    //         }
    //         getAllSimilarProducts(search)
    //     }
    // }, [product ? product.id : 0])

    // useEffect(() => {
    //     setIsLoading(false)
    //     // setViewProduct(search_allsimilar.records.length ? search_allsimilar.records : [])
    // }, [search_allsimilar])

    useEffect(() => {
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    useEffect(() => {
        if (product) {
            if (product.allattachmentlist) {
                if (product.allattachmentlist.length) {
                    product.allattachmentlist.forEach(function (data) {
                        data['original'] = isValidHttpUrl(data.file_name)
                            ? data.file_name
                            : global.images_url + data['file_name']
                        data['thumbnail'] = isValidHttpUrl(data.file_name)
                            ? data.file_name
                            : global.images_url + data['file_name']
                    })

                    setImages(product.allattachmentlist)
                } else {
                    setImages([])
                }
            } else {
                setImages([])
            }
            // getAllBidHistory({
            //     limit: 10,
            //     page: 1,
            //     id: product.id,
            //     filters: {

            //     }
            // })
        } else {
            setImages([])
        }
    }, [product])

    useEffect(() => {
        if (responseStatusBid) {
            if (responseStatusBid.from === 'bidCancel') {
                if (responseStatusBid.status === 'success') {
                    getAllBidHistory({
                        limit: 10,
                        page: 1,
                        id: product?.id,
                    })
                    setAlert(responseStatusBid.message, 'success')
                    clearResponseBid()
                } else {
                    setAlert(responseStatusBid.message, 'error')
                    clearResponseBid()
                }
            }
        }
    }, [responseStatusBid])

    const cancelBid = () => {
        if (search_allbidhistory?.records?.length > 0) {
            let topValid = search_allbidhistory.records.find((bid) => bid.declined === 0)
            bidCancel({ id: topValid.bidid })
        }
    }

    const isBidCanceAllowed = () => {
        let diff = 0
        if (product.date_closed) {
            diff = new Date(product.date_closed).getTime() - new Date().getTime()
        }
        let allowed = product.custom_auctionlot_bid_retract_minutes * 60 * 1000
        return (
            product.custom_auctionlot_bid_retract_check === 1 &&
            product.custom_auctionlot_bid_retract_minutes > 0 &&
            search_allbidhistory.records?.length > 0 &&
            diff > 0 &&
            diff > allowed
        )
    }

    const substractMinutes = (date, minutes) => {
        const d = new Date(date)
        const newTime = d.getTime() - minutes * 60 * 1000
        const newDate = new Date(newTime)
        return newDate.toISOString()
    }

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false)
    }
    const closePopUp = () => {
        setManage(false)
        formik.handleReset()
    }
    const handleMessageSubmit = async (values) => {
        let messageFormData = {
            ...values,
            attachinsidename: '',
            attachorginalname: '',
            sellermsgpost: product.user_id,
            status: 'open',
            user_id: user.id,
            projectmsgpost: product.id,
        }

        saveMessage(messageFormData)
    }
    const formik = useFormik({
        initialValues: {
            message: '',
        },

        onSubmit: (values) => {
            handleMessageSubmit(values)
            setManage(false)
            formik.handleReset()
        },
    })
    // const isPrivateCheck = (details) => {
    //     let result = false
    //     if (user && user.id > 0 && details.custom_auctionlot_auctionstatus === 'Private') {
    //         result = true
    //         if (details.auctionlot_selectedbuyer) {
    //             if (details.auctionlot_selectedbuyer?.split(',')?.includes(user.id?.toString())) {
    //                 return false
    //             } else {
    //                 if (
    //                     product.selectedbuyer &&
    //                     product.selectedbuyer?.split(',')?.includes(user.id?.toString())
    //                 ) {
    //                     return false
    //                 } else {
    //                     return true
    //                 }
    //             }
    //         } else {
    //             if (
    //                 product.selectedbuyer &&
    //                 product.selectedbuyer?.split(',')?.includes(user.id?.toString())
    //             ) {
    //                 return false
    //             } else {
    //                 return true
    //             }
    //         }
    //     }
    //     return result
    // }
    const isPrivateCheck = (details, auction) => {
        let result = true
        if (user && user.id > 0 && user?.initial_bu_status == 2) {
            //result = true
            if (
                auction &&
                auction?.custom_bu_sign_document &&
                auction?.bidder_undertaking_status != 1
            ) {
                return true
            } else if (details?.entire_auction_access) {
                return false

                // if (details.selectedviewer?.split(',')?.includes(user.id?.toString())) {
                //     return false
                // } else {
                //     return true
                // }
            } else if (details?.entire_project_access) {
                return false
            } else {
                return true
            }
        }
        return result
    }

    const message = []
    message.push({
        label: 'Message',
        placeholder: `Type message to admin`,
        class: 'col-md-12',
        name: 'message',
        formik: formik,
    })
    console.log(isLoading, 'isLoading')
    const ignoreArray = ['lotfacilityname', 'lot_desc', 'subauctionid', 'datte_added']
    return (
        <>
            <SEO title="Auction View" url={window.location.href} />
            <div className="productView" id="productView">
                {manage && (
                    <CustomDialog
                        title={
                            <div className="d-flex align-items-center justify-content-between">
                                Message
                                <IconButton onClick={() => closePopUp(false)}>
                                    <span className="material-icons">clear</span>
                                </IconButton>
                            </div>
                        }
                        open={manage}
                    >
                        <form>
                            <div className="row mb-4">{Object.values(mapData(message))}</div>
                            <div className="actionWrapper">
                                <PrimaryButton
                                    onClick={formik.handleSubmit}
                                    id="confirm_bid_submit"
                                    type="button"
                                    label={'Submit'}
                                />
                            </div>
                        </form>
                    </CustomDialog>
                )}
                {isLoading ? (
                    <Loaders name="product_view" isLoading={isLoading} loop={1} />
                ) : product ? (
                    <div className="">
                        <Button
                            id="productView_close"
                            className="closeSlider position-absolute"
                            onClick={props.drawerHandler}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                        {isAuthenticated && (
                            <>
                                {product.auctionlot_auctiontype != 'sealed' ||
                                product.sub_auctiontype == 'status' ? (
                                    <>
                                        {product.bidtopstatus === 'outbid' && (
                                            <div className="pvBidStatus">
                                                <h4 className="outbid">
                                                    {(product.sub_auctiontype == 'status'
                                                        ? product.current_bid
                                                        : product.wprice) < product.rprice
                                                        ? 'Reserve not met'
                                                        : 'You have been outbid'}
                                                    .
                                                </h4>
                                            </div>
                                        )}
                                        {product.bidtopstatus === 'winner' && (
                                            <div className="pvBidStatus">
                                                <h4 className="winning">
                                                    {(product.sub_auctiontype == 'status'
                                                        ? product.current_bid
                                                        : product.wprice) < product.rprice
                                                        ? 'Reserve not met'
                                                        : 'You are winning this item'}
                                                    .
                                                </h4>
                                            </div>
                                        )}
                                        {product.bidtopstatus === 'won' && (
                                            <div className="pvBidStatus">
                                                <h4 className="won">
                                                    {t(
                                                        'Congratulations, you are the Highest Bidder',
                                                    )}
                                                </h4>
                                            </div>
                                        )}
                                        {product.bidtopstatus === 'lost' && (
                                            <div className="pvBidStatus">
                                                <h4 className="lost">
                                                    {t('Unfortunately you have lost this item')}
                                                </h4>
                                            </div>
                                        )}
                                    </>
                                ) : null}
                            </>
                        )}

                        <div className="d-flex flex-wrap">
                            {/* {isAuthenticated ? (
                                    <>
                                        <div className="pvBidBox">
                                            {product.market_status === 'open' &&
                                            !product.future_active ? (
                                                <>
                                                    {product.auction ? (
                                                        <>
                                                            <Bidding data={product} type="proxy" />
                                                            <Bidding data={product} type="hard" />
                                                        </>
                                                    ) : null}

                                                    {product.buynow &&
                                                    product.bprice >= product.wprice ? (
                                                        <Buynow
                                                            data={product}
                                                            editQuantity={true}
                                                            isOnlyBuynow={
                                                                product.auction === 0 ? true : false
                                                            }
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            ) : null}
                                        </div>
                                        {product.bidtopstatus === 'winner' && (
                                            <div className="pvBidStatus">
                                                <h4 className="winning">
                                                    {'Yayy you are winning this item caps'}.
                                                </h4>
                                            </div>
                                        )}
                                        {product.bidtopstatus === 'won' && (
                                            <div className="pvBidStatus">
                                                <h4 className="won">
                                                    {'Congratulations you have won this item'}
                                                </h4>
                                            </div>
                                        )}
                                        {product.bidtopstatus === 'lost' && (
                                            <div className="pvBidStatus">
                                                <h4 className="lost">
                                                    {'Unfortunately you have lost this item'}
                                                </h4>
                                            </div>
                                        )}
                                    </>
                                )} */}
                            <div className="pvLt">
                                <ImageGallery
                                    items={images}
                                    thumbnailPosition="bottom"
                                    showNav={false}
                                    onErrorImageURL="/assets/images/noImage.png"
                                    showBullets={false}
                                    showFullscreenButton={true}
                                    showPlayButton={false}
                                />
                            </div>
                            {/* <PrimaryButton
                                id="place_hard_bid"
                                label={'Contact Seller'}
                                type="submit"
                                btnSize="small"
                                onClick={() => setManage(true)}
                            /> */}
                            <div className="pvRt">
                                <div>
                                    <div className="pvProductInfo mt-4">
                                        <h2 className="googleSearch">
                                            #{product.id} - {product.title}{' '}
                                            {/* <a
                                                target="_blank"
                                                rel="noreferrer"
                                                className="googleSearch"
                                                href={`https://www.google.com/search?q=${product.title}`}
                                            >
                                                <span className="material-icons">search</span>
                                            </a> */}
                                        </h2>
                                    </div>
                                    {product.market_status === 'open' ? (
                                        <div className="pvTimerBox">
                                            <span className="material-icons-outlined">timer</span>
                                            <h4>
                                                <Timer
                                                    date_added={product.date_added}
                                                    date_closed={product.date_closed}
                                                    withText={1}
                                                    endText="Time Left: "
                                                    startText="Starts in: "
                                                ></Timer>
                                            </h4>
                                        </div>
                                    ) : (
                                        <div className="pvTimerBox">
                                            <span className="material-icons">timer</span>
                                            <label>{t('Closed on')}</label>
                                            <h4>{dateFormatFront(product.date_closed)}</h4>
                                        </div>
                                    )}

                                    <>
                                        {' '}
                                        {/* {!isPrivateCheck(product) ? (
                                            <> */}{' '}
                                        <div className="pvActBtn d-flex justify-content-around align-items-center">
                                            {product.market_status === 'open' ? (
                                                <>
                                                    {product.buynow &&
                                                    product.wprice < product.bprice ? (
                                                        <div className="pabChild">
                                                            <label>{t('Buy Now Price')}</label>
                                                            <h4>
                                                                {currencyFormat(
                                                                    product.bprice * product.qty,
                                                                )}
                                                            </h4>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}

                                                    {product.auction ? (
                                                        user?.initial_bu_status == 2 ? (
                                                            !isPrivateCheck(
                                                                product,
                                                                auctionDetails,
                                                            ) ? (
                                                                <>
                                                                    {product.auctionlot_auctiontype !=
                                                                    'sealed' ? (
                                                                        <div className="pabChild pvCurrentBid">
                                                                            <label>
                                                                                {product.cbidtext}
                                                                            </label>
                                                                            <h4>
                                                                                {currencyFormat(
                                                                                    product.wprice,
                                                                                )}
                                                                            </h4>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="pabChild pvCurrentBid">
                                                                            {product.auctionlot_auctiontype ==
                                                                            'sealed' ? (
                                                                                <label>
                                                                                    My Offer
                                                                                </label>
                                                                            ) : (
                                                                                <label>
                                                                                    My Bid
                                                                                </label>
                                                                            )}

                                                                            <h4>
                                                                                {currencyFormat(
                                                                                    product.bid_or_not
                                                                                        ? product.current_bid
                                                                                        : 0,
                                                                                )}
                                                                            </h4>
                                                                        </div>
                                                                    )}
                                                                    {product.auctionlot_auctiontype !==
                                                                        'sealed' &&
                                                                    product.next_bid > 0 ? (
                                                                        <div className="pabChild">
                                                                            <label>
                                                                                {t('Minimum Bid')}
                                                                            </label>
                                                                            <h4>
                                                                                {currencyFormat(
                                                                                    product.next_bid,
                                                                                )}
                                                                            </h4>
                                                                        </div>
                                                                    ) : null}
                                                                </>
                                                            ) : null
                                                        ) : null
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            ) : product.buynowamount ? (
                                                <>
                                                    {product.auctionlot_auctiontype != 'sealed' ? (
                                                        <div className="pabChild pvCurrentBid">
                                                            <label>{product.cbidtext}</label>
                                                            <h4>
                                                                {currencyFormat(
                                                                    product.buynowamount,
                                                                )}
                                                            </h4>
                                                        </div>
                                                    ) : null}
                                                </>
                                            ) : null}
                                        </div>
                                        {/* </>
                                        ) : null} */}
                                    </>

                                    {/* {isAuthenticated ? (
                                        <> */}
                                    <>
                                        {!isPrivateCheck(product, auctionDetails) &&
                                        product.market_status === 'open' ? (
                                            <>
                                                {' '}
                                                <div className="pvBidBox">
                                                    {product.market_status === 'open' &&
                                                    !product.future_active ? (
                                                        <>
                                                            {product.auction ? (
                                                                <>
                                                                    {product.bid_limit_auction >
                                                                    0 ? (
                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                            }}
                                                                        >
                                                                            {' '}
                                                                            {product.auctionlot_auctiontype ===
                                                                            'sealed' ? (
                                                                                <h6>
                                                                                    Offers Remaining
                                                                                    :
                                                                                </h6>
                                                                            ) : (
                                                                                <h6>
                                                                                    Bids Remaining :
                                                                                </h6>
                                                                            )}{' '}
                                                                            <h6>
                                                                                {parseInt(
                                                                                    product.bid_limit,
                                                                                    10,
                                                                                ) -
                                                                                    product.hardbid_count}
                                                                            </h6>
                                                                        </div>
                                                                    ) : null}
                                                                    {product.auctionlot_auctiontype ==
                                                                    'reverse' ? (
                                                                        <>
                                                                            {product.bid_limit_auction >
                                                                            0 ? (
                                                                                <ReverseBidding
                                                                                    data={product}
                                                                                    type="hard"
                                                                                    disabled={
                                                                                        product.sprice <=
                                                                                        0
                                                                                            ? true
                                                                                            : product.bid_limit_auction >
                                                                                                  0 &&
                                                                                              parseInt(
                                                                                                  product.bid_limit,
                                                                                                  10,
                                                                                              ) -
                                                                                                  product.hardbid_count ==
                                                                                                  0
                                                                                            ? true
                                                                                            : false
                                                                                    }
                                                                                />
                                                                            ) : (
                                                                                <>
                                                                                    <CustomReverseBidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type="hard"
                                                                                        disabled={
                                                                                            product.sprice <=
                                                                                            0
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                    />
                                                                                    <ReverseBidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        disabled={
                                                                                            product.sprice <=
                                                                                            0
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        type="proxy"
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {console.log(
                                                                                product.custom_auctionlot_bid_type,
                                                                                product.bid_type,
                                                                                'biddd',
                                                                            )}
                                                                            {product.custom_auctionlot_bid_type ===
                                                                            'hard' ? (
                                                                                <Bidding
                                                                                    data={product}
                                                                                    type={'hard'}
                                                                                    disabled={
                                                                                        product.sprice <=
                                                                                        0
                                                                                            ? true
                                                                                            : false
                                                                                    }
                                                                                />
                                                                            ) : product.auctiontype ===
                                                                              'sealed' ? (
                                                                                product.sub_auctiontype ===
                                                                                'status' ? (
                                                                                    <>
                                                                                        {product.bid_limit_auction >
                                                                                        0 ? null : (
                                                                                            <Bidding
                                                                                                disabled={
                                                                                                    product.sprice <=
                                                                                                    0
                                                                                                        ? true
                                                                                                        : false
                                                                                                }
                                                                                                data={
                                                                                                    product
                                                                                                }
                                                                                                type="sealed"
                                                                                            />
                                                                                        )}

                                                                                        <ProxyBidding
                                                                                            data={
                                                                                                product
                                                                                            }
                                                                                            type="sealed"
                                                                                            disabled={
                                                                                                product.sprice <=
                                                                                                0
                                                                                                    ? true
                                                                                                    : product.bid_limit_auction >
                                                                                                          0 &&
                                                                                                      parseInt(
                                                                                                          product.bid_limit,
                                                                                                          10,
                                                                                                      ) -
                                                                                                          product.hardbid_count ==
                                                                                                          0
                                                                                                    ? true
                                                                                                    : false
                                                                                            }
                                                                                        />
                                                                                    </>
                                                                                ) : (
                                                                                    <ProxyBidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type="sealed"
                                                                                        disabled={
                                                                                            product.sprice <=
                                                                                            0
                                                                                                ? true
                                                                                                : product.bid_limit_auction >
                                                                                                      0 &&
                                                                                                  parseInt(
                                                                                                      product.bid_limit,
                                                                                                      10,
                                                                                                  ) -
                                                                                                      product.hardbid_count ==
                                                                                                      0
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                    />
                                                                                )
                                                                            ) : (
                                                                                //                 product.custom_auctionlot_bid_type ===
                                                                                //   'proxy' ? (
                                                                                //     <Bidding
                                                                                //         data={product}
                                                                                //         type={'proxy'}
                                                                                //     />
                                                                                //                 )
                                                                                //                     :
                                                                                <>
                                                                                    <Bidding
                                                                                        data={
                                                                                            product
                                                                                        }
                                                                                        type={
                                                                                            'hard'
                                                                                        }
                                                                                        disabled={
                                                                                            product.sprice <=
                                                                                            0
                                                                                                ? true
                                                                                                : product.bid_limit_auction >
                                                                                                      0 &&
                                                                                                  parseInt(
                                                                                                      product.bid_limit,
                                                                                                      10,
                                                                                                  ) -
                                                                                                      product.hardbid_count ==
                                                                                                      0
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                    />
                                                                                    {isAuthenticated &&
                                                                                    !product.bid_limit_auction ? (
                                                                                        <ProxyBidding
                                                                                            data={
                                                                                                product
                                                                                            }
                                                                                            type="proxy"
                                                                                            disabled={
                                                                                                product.sprice <=
                                                                                                0
                                                                                                    ? true
                                                                                                    : false
                                                                                            }
                                                                                        />
                                                                                    ) : null}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : null}
                                                            {product.buynow &&
                                                            product.bprice >= product.wprice ? (
                                                                <Buynow
                                                                    data={product}
                                                                    editQuantity={true}
                                                                    isOnlyBuynow={
                                                                        product.auction === 0
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                            ) : (
                                                                ''
                                                            )}

                                                            {product.makeoffer ? (
                                                                <Makeoffer
                                                                    data={product}
                                                                    minimumAmount={product.next_bid}
                                                                />
                                                            ) : (
                                                                ''
                                                            )}
                                                        </>
                                                    ) : null}
                                                </div>
                                                {isAuthenticated ? (
                                                    <Button
                                                        id="view_bid_history"
                                                        className="pvBidHistBtn mt-5"
                                                        onClick={() =>
                                                            setBidHistoryValue(product.id)
                                                        }
                                                    >
                                                        <span className="material-icons">
                                                            history
                                                        </span>{' '}
                                                        {product.auctionlot_auctiontype == 'sealed'
                                                            ? 'View Offer history'
                                                            : 'View bid history'}
                                                    </Button>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        ) : product.market_status == 'closed' ||
                                          product.market_status == 'sold' ||
                                          product.market_status == 'unsold' ? (
                                            <>
                                                {' '}
                                                <PrimaryButton
                                                    id="make_pay_grid"
                                                    label={'Auction Closed'}
                                                    btnSize="small"
                                                    // onClick={() =>
                                                    //     handleRedirectInternal(
                                                    //         history,
                                                    //         `checkout/invoice/${product.common_invoice}`,
                                                    //     )
                                                    // }
                                                />
                                            </>
                                        ) : (
                                            <PrimaryButton
                                                id="make_pay_grid"
                                                label={'No Bidding Rights'}
                                                btnSize="small"
                                                onClick={() => {
                                                    if (!isAuthenticated) {
                                                        handleLoginPopup()
                                                    } else if (user && !user.is_kyc_done) {
                                                        handleKycPopup()
                                                    }
                                                }}
                                            />
                                        )}
                                    </>
                                    {/* </>
                                    ) : (
                                        <PrimaryButton
                                            id="productView_loginBtn"
                                            btnSize="mt-3"
                                            label={
                                                product.auction
                                                    ? t('Login to bid')
                                                    : t('Login to buy')
                                            }
                                            onClick={() => handleRedirectInternal(history, 'login')}
                                        />
                                    )} */}

                                    <div className="pvProductDesc mt-3 mb-3">
                                        {/* <div className="pvDescChild">
                                            <label>{t('auction')} id:</label>
                                            <h6>#{product.auctionid}</h6>
                                        </div> */}
                                        <div className="pvDescChild">
                                            <label>{t('Lot ID:')}</label>
                                            <h6>##{product.id}</h6>
                                        </div>
                                        {/* <div className="pvDescChild">
                                            <label>{t('auction_name')}:</label>
                                            <h6>{product.auctionlot_title}</h6>
                                        </div> */}

                                        <div className="pvDescChild">
                                            <label>{t('Auction ends')}:</label>
                                            <h6>{dateFormatFront(product.date_closed)}</h6>
                                        </div>

                                        {/* <div className="pvDescChild">
                                        <label>Product Owner:</label>
                                        <h6>Spencer C</h6>
                                    </div> */}
                                        <div className="pvDescChild">
                                            <label>{t('Available quantity')}:</label>
                                            <h6>{product.qty}</h6>
                                        </div>

                                        {/* <div className="pvDescChild">
                                            <label>{t('Description')}:</label>
                                            <span>
                                                {product.desc_proc && product?.desc_proc[0] === '<'
                                                    ? product.desc_proc
                                                          .replace('<p>', '')
                                                          .replace('</p>', '')
                                                    : product.desc_proc}
                                            </span>
                                        </div>
                                        {console.log(product, 'props.arrayValue')}
                                        <div className="pvDescChild">
                                                <label>Additional Info</label>
                                                <span>{product?.additional_info}</span>
                                            </div>
                                       {/* <div className='pvMiscInfoCnt'>
                                       <DynamicView
                                            product={product}
                                            arrayValue={props.arrayValue}
                                            updateLoading={updateLoading}
                                            ignoreArray={ignoreArray}
                                        />
                                       </div> */}
                                        <div className="pvMiscInfoCnt">
                                            <div className="pvDescChild">
                                                <label>Lot ID:</label>
                                                <h6>{product?.id}</h6>
                                            </div>
                                            <div className="pvDescChild">
                                                <label>Lot Number:</label>
                                                <h6>{product?.lotnumber}</h6>
                                            </div>
                                            <div className="pvDescChild">
                                                <label>Make:</label>
                                                <h6>{product?.make}</h6>
                                            </div>

                                            <div className="pvDescChild">
                                                <label>Model:</label>
                                                <h6>{product?.model}</h6>
                                            </div>
                                            <div className="pvDescChild">
                                                <label>Manufactured on:</label>
                                                <h6>{product?.mfgyear}</h6>
                                            </div>
                                            <div className="pvDescChild">
                                                <label>UOM:</label>
                                                <h6>{product?.unitofmessurement}</h6>
                                            </div>
                                            <div className="pvDescChild">
                                                <label>Location:</label>
                                                <h6>{product?.lotlocation}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pvDescChild">
                                        <label>Description:</label>
                                        <h6>{product?.lot_desc}</h6>
                                    </div>
                                    {/* <div className="pvAccordian mt-2 mb-2 w-100">
                                        {accordianData.map((data, index) => (
                                            <Accordion
                                                square
                                                expanded={expanded === `panel${index}`}
                                                key={index}
                                                onChange={handleChange(`panel${index}`)}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1d-content"
                                                    id={`panel${index}d-header`}
                                                >
                                                    <h6 className="accTitle">{data.title}</h6>
                                                </AccordionSummary>
                                                <AccordionDetails>{data.details}</AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </div> */}
                                </div>
                                {/* <Comments product={product} /> */}
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </>
    )
}
export default ProductView
